/* eslint-disable @typescript-eslint/no-unused-vars */
import { z } from 'zod'

import type { Equal, ExpectTrue } from '../types/validation'

import { type CTALink, CTALinkSchema } from './cta-link'
import { type ProductQuery, ProductQuerySchema } from './product-query'

export const RefinedProductsLayout = {
  SLIDER: 'slider',
  GRID: 'grid',
} as const

/* TypeScript */
export type RefinedProductsLayout =
  (typeof RefinedProductsLayout)[keyof typeof RefinedProductsLayout]

export type ProductGranularity = 'parent' | 'variant' | 'backbox'

export type RefinedProductsApiProps = {
  technicalName?: string
  title?: string
  subtitle?: string
  ctaLink?: CTALink
  productLayout: RefinedProductsLayout
  productQuery: ProductQuery
  productGranularity?: ProductGranularity
}

/* Schemas */
export const RefinedProductsLayoutSchema = z.enum([
  RefinedProductsLayout.SLIDER,
  RefinedProductsLayout.GRID,
])

export const ProductGranularity = z.enum(['parent', 'variant', 'backbox'])

export const RefinedProductsApiPropsSchema = z.object({
  technicalName: z.string().optional(),
  title: z.string().optional(),
  subtitle: z.string().optional(),
  ctaLink: CTALinkSchema.optional(),
  productLayout: RefinedProductsLayoutSchema,
  productQuery: ProductQuerySchema,
  productGranularity: ProductGranularity.optional(),
})

/* Schemas validation */
type TestRefinedProductsApiProps = ExpectTrue<
  Equal<RefinedProductsApiProps, z.infer<typeof RefinedProductsApiPropsSchema>>
>
